import { render, staticRenderFns } from "./ExtratoHonorariosComTransfEfSefa.vue?vue&type=template&id=35d58249&scoped=true&"
import script from "./ExtratoHonorariosComTransfEfSefa.vue?vue&type=script&lang=js&"
export * from "./ExtratoHonorariosComTransfEfSefa.vue?vue&type=script&lang=js&"
import style0 from "./ExtratoHonorariosComTransfEfSefa.vue?vue&type=style&index=0&id=35d58249&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d58249",
  null
  
)

export default component.exports